import React, { useState, useEffect } from 'react';
import {
    Text, View, TextInput, StyleSheet,
    ScrollView, TouchableOpacity, KeyboardAvoidingView, Pressable
} from 'react-native';
import { store } from "../../store/store";
import { doPost } from '../../utils/services/api/API';
import { updateFamilyData, updateUserDetails } from '../../utils/services/redux/commonRedux';
import { familyDetailsSubscription, userDetailsSubscription } from "../../utils/services/subject-behaviour/CommonRxjsService";

import { PrimaryCTA } from '../../utils/widgets/CommonCTA';
import { CommonHeader } from "../../utils/widgets/CommonWidget/CommonHeader";
import { LocationIconView } from '../../utils/widgets/Location/Location-Widget';

import { LocationName, memberRelation } from '../../utils/constants/ConstantsMapping';

import AppTheme from '../../AppTheme';
import AppStyles from "../../AppStyles";
import disableScroll from "disable-scroll"

import TitlePopup from '../../utils/modals/TitlePopup';

import * as DateTime from "../../utils/services/DateTimeUtils";
import * as CommonUtils from '../../utils/services/CommonUtils';
import * as MoengageUtils from "../../utils/services/webapp-services/MoengageUtils";
import * as AlertService from "../../utils/services/AlertLoaderService";

const AddUpdateMember = (props) => {
    const reduxState = store.getState();
    var userObj: any = reduxState.addUpdateScreenData;
    const isProfileComplete = reduxState.userDetails?.['isProfileComplete'];

    const [maleGenderSelected, setmaleGenderSelected] = useState(true);
    const [name, setName] = useState('');
    const [age, setAge] = useState('0');

    const [selectedRelation, setselectedRelation] = useState('');
    const [locationCoOrdinate, setlocationCoOrdinate] = useState('');
    const [locationStatus, setLocationStatus] = useState('');
    const [genderSelected, setGenderSelected] = useState(false);

    const [upsertUserPopupData, setUpsertUserPopupData] = useState({ active: false, title: '' });

    useEffect(() => {
        setGenderSelected(userObj.isUpdate ? true : false);
        setName(userObj.isUpdate ? isProfileComplete ? userObj.user.name : '' : '')
        setAge(userObj.isUpdate ? isProfileComplete ? DateTime.getAgeFromTs(userObj.user.dob).toString() : DateTime.getAgeFromTs(userObj.user.dob).toString() : '')
        setselectedRelation(userObj.isSelf ? 'Self' : userObj.isUpdate ? userObj.user.relation : '')
        setmaleGenderSelected(userObj?.isUpdate && userObj?.user?.gender === 'Female' ? false : true);
        setLocationStatus(userObj['user'] ? userObj['user']['address'] : 'Select Your location');
        userObj.isUpdate && userObj.isSelf ? getYourCurrentPosition() : null
        props.navigation.setOptions({
            title: userObj?.isUpdate ? 'Update Member' : 'Add Member',
        });
    }, [])

    const onUpsertUser = () => { props.navigation.pop() }

    const showUpsertUserPopup = (title) => {
        // disableScroll.on()
        setUpsertUserPopupData({ active: true, title: title })
    }

    const closeUpsertUserPopup = () => {
        disableScroll.off()
        setUpsertUserPopupData({ active: false, title: '' })
    }

    function getYourCurrentPosition() {
        if (userObj['user'] && userObj['user']['address']) {
            setLocationStatus(userObj['user']['address'])
        } else {
            navigator.geolocation.getCurrentPosition(function (position) {
                let coordinates = `${position.coords.latitude}, ${position.coords.longitude}`
                setlocationCoOrdinate(coordinates);
                setLocationStatus('We have recorded your location')
            });
        }

    }

    const saveMember = () => {

        const reduxState = store.getState();
        var params = {
            'name': name,
            'gender': maleGenderSelected ? 'Male' : 'Female',
            'dob': DateTime.getTsFromAge(parseInt(age)),
            'location': userObj.isSelf ? locationCoOrdinate : userObj?.user?.relation === 'Self' ? locationCoOrdinate : '',
            'relation': userObj.isSelf ? 'Self' : selectedRelation,
            'userId': userObj?.user?.id ? userObj['user']['id'] : 0,
            "appGUID": "",
            timezone: DateTime.getWebTimezone()
        };

        var isUpdate = userObj.isUpdate ? true : false;

        let familyMembers = reduxState['familydetails']['familyMembers'];
        let duplicateMember = false;
        duplicateMember = familyMembers.find(member => {
            if ((params.relation.toLowerCase() == 'father' ||
                params.relation.toLowerCase() == 'mother') &&
                member.relation.toLowerCase() == params.relation.toLowerCase()) {
                return !isUpdate;
            }
            if (member.gender === params.gender && member.relation === params.relation &&
                DateTime.getDOBDateTime(member.dob) === DateTime.getDOBDateTime(params.dob) &&
                member.name === params.name) {
                return true;
            }
        });

        if (duplicateMember)
            showUpsertUserPopup(`${name} is already exists!`)
        else {
            AlertService.loaderModal.setLoader(true);
            if (isUpdate) {
                var urn = 'accounts/update_user';
            } else var urn = 'accounts/add_member';
            setselectedRelation('');
            doPost(urn, params, true).then(
                (response: any) => {
                    if (!userObj.isUpdate) MoengageUtils.trackMoengageEvents('add_member')
                    let familyDetails = reduxState['familydetails'];

                    if (familyDetails) {
                        let userIndex = familyDetails['familyMembers'].
                            findIndex((obj => obj.id == response.id));

                        if (userIndex !== null && userIndex !== undefined && userIndex !== -1) {
                            familyDetails['familyMembers'][userIndex] = response;
                        } else {
                            familyDetails['familyMembers'].push(response);
                        }
                    }

                    if (userObj.isSelf) {
                        var userData = response;
                        userData['isProfileComplete'] = true
                        userData['isNameCaptured'] = true
                        userData['familyId'] = familyDetails['familyId']
                        updateUserDetails(userData)
                        userDetailsSubscription.setUserDetails(userData)
                    }

                    updateFamilyData(familyDetails);
                    familyDetailsSubscription.setFamilyDetails(familyDetails['familyMembers'])
                    AlertService.loaderModal.setLoader(false);
                    var popupTitle = ''
                    if (userObj.isUpdate) {
                        if (userObj.isSelf) popupTitle = 'Your profile is updated!'
                        else popupTitle = `${name}\'s profile is succesfully updated`
                    } else popupTitle = `${name} is succesfully added`
                    showUpsertUserPopup(popupTitle)
                }
            )
        }
    }

    return (
        <KeyboardAvoidingView style={{ flex: 1, width: AppTheme.appWidth }}>
            <CommonHeader navigation={props.navigation}
                isSelf={userObj.isUpdate && userObj.isSelf}
                userName={name} title={userObj?.isUpdate ? 'Update Profile' : 'Add New Member'} />
            <ScrollView style={{ marginTop: AppTheme.headerHeight }}>
                <View style={{ flex: 1 }}>

                </View>

                <View style={{ marginBottom: 12, marginHorizontal: 16, marginTop: 16 }}>
                    {/* <Text style={styles.inputLables}>NAME</Text> */}

                    <Text style={[styles.inputLables]}>Enter Name</Text>
                    <View style={styles.sectionStyle}>
                        {/* <Image
                            source={{ uri: CommonUtils.getImagePath('/images/userinfoName.png') }}
                            style={styles.imageStyle} /> */}
                        <TextInput
                            style={styles.input}
                            placeholder="Enter full name"
                            underlineColorAndroid="transparent"
                            value={name}
                            onChangeText={(text) => {
                                setName(text.replace(/[^a-z A-Z]/g, ''))
                            }} />
                    </View>
                </View>

                <View style={{ marginBottom: 12, marginHorizontal: 16 }}>
                    {/* <Text style={styles.inputLables}>DATE OF BIRTH</Text> */}

                    <Text style={[styles.inputLables]}>Enter Age</Text>
                    <View style={styles.sectionStyle}>
                        <TextInput
                            style={styles.input}
                            placeholder="Enter age in years"
                            underlineColorAndroid="transparent"
                            value={age}
                            keyboardType="numeric"
                            onChangeText={(text) => setAge(text.replace(/[^0-9]/g, ''))} />
                        {/* <Image
                            source={{ uri: CommonUtils.getImagePath('/images/userinfoAge.png') }}
                            style={styles.imageStyle}
                        /> */}
                        {/* <input style={{
                            flex: 1, borderWidth: 0, borderBottomWidth: 2,
                            fontSize: 14, fontWeight: 600, padding: 5, outlineWidth: 0
                        }} onChange={(event) => { onDateChange(event) }} id="dateRequired" max={new Date(new Date().getTime() - new Date().getTimezoneOffset() * 60000).toISOString().split("T")[0]} type="date" name="dateRequired" value={dateOfBirth} />
                   */}
                    </View>
                </View>
                <View style={AppStyles.m16}>
                    <Text style={styles.inputLables}>Select Gender</Text>
                    <View style={styles.genderSection}>
                        <Pressable onPress={() => {
                            !maleGenderSelected && userObj?.isSelf === false ?
                                setselectedRelation('') : '';
                            setmaleGenderSelected(true);
                            setGenderSelected(true)
                        }} >
                            <View>
                                <Text style={[styles.genderText, {
                                    marginRight: 16,
                                    color: (genderSelected && maleGenderSelected) ? '#fff' : '#000000',
                                    backgroundColor: (genderSelected && maleGenderSelected) ? AppTheme.color.blue.cta : ''
                                }]}>Male</Text>
                                {/* <Image source={{ uri: CommonUtils.getImagePath('/images/userinfoMale.png') }}
                                    style={[styles.genderImages, maleGenderSelected ? styles.imageBorder : null]} /> */}
                            </View>
                        </Pressable>
                        <Pressable onPress={() => {
                            maleGenderSelected && userObj?.isSelf === false ?
                                setselectedRelation('') : '';
                            setmaleGenderSelected(false);
                            setGenderSelected(true)
                        }} >
                            <View>
                                <Text style={[styles.genderText, {
                                    color: (genderSelected && !maleGenderSelected) ? '#fff' : '#000000',
                                    backgroundColor: (genderSelected && !maleGenderSelected) ? AppTheme.color.blue.cta : ''
                                }]}>Female</Text>
                                {/* <Image source={{ uri: CommonUtils.getImagePath('/images/userinfoFemale.png') }}
                                    style={[styles.genderImages, !maleGenderSelected ? styles.imageBorder : null]} /> */}
                            </View>
                        </Pressable>
                    </View>
                </View>
                {genderSelected && ((!userObj && !userObj.isSelf) || (userObj?.user?.relation !== 'Self' && !userObj.isSelf)) && <View style={AppStyles.m16}>
                    <Text style={styles.inputLables}>Relation</Text>
                    <View style={styles.relationSelection}>
                        {
                            memberRelation[maleGenderSelected ? 'Male' : 'Female'].map((item, i) => (
                                <TouchableOpacity key={i}
                                    onPress={() => { setselectedRelation(item); }}
                                    style={[styles.familyMembers, {
                                        backgroundColor: selectedRelation === item ?
                                            AppTheme.color.blue.cta : '#fff'
                                    }]} ><Text style={[styles.relations, {
                                        color: selectedRelation === item ? '#fff' : '#000000'
                                    }]}> {item} </Text>
                                </TouchableOpacity>
                            ))
                        }
                    </View>
                </View>
                }

                <View style={AppStyles.mx16}>
                    {
                        (userObj?.user?.relation === 'Self' || userObj.isSelf) && isProfileComplete && locationStatus ?
                            <View>
                                <Text style={styles.inputLables}>Location</Text>
                                <View style={[styles.sectionStyle, { justifyContent: 'flex-start' }]}>
                                    {LocationIconView({
                                        locationName: LocationName.home,
                                        height: 18,
                                        width: 18
                                    })}
                                    <Text style={{ marginLeft: 4 }}>{locationStatus}</Text>
                                </View>

                            </View> : null
                    }

                </View>
                <View style={AppStyles.m16}>
                    <PrimaryCTA onPress={() => saveMember()}
                        text={userObj.isUpdate ? 'Save' : 'Add'}
                        disabled={name === '' || !age || parseInt(age) > 120 ||
                            selectedRelation === '' ||
                            (/\d/.test(name)) || isNaN(parseInt(age))} />
                </View>

            </ScrollView>

            <TitlePopup showPopup={upsertUserPopupData.active}
                modalData={{ title: upsertUserPopupData.title }}
                closeModal={closeUpsertUserPopup}
                primaryAction={onUpsertUser} />

        </KeyboardAvoidingView>
    )
}

export default AddUpdateMember;

const styles = StyleSheet.create(CommonUtils.addFontFamilylato({
    genderText: {
        padding: 16, textAlign: 'center', borderRadius: 4, color: 'rgba(0, 0, 0, 0.6)', fontSize: 16,
        borderWidth: 1, borderColor: 'rgba(0, 0, 0, 0.12)', width: 90
    },
    inputLables: {
        fontSize: 14, color: '#cc00000', paddingBottom: 8
    },
    input: {
        flex: 1, height: 35, fontSize: 16, fontWeight: 'normal', padding: 10,
        borderColor: '#7a42f4', color: 'rgba(0, 0, 0)'
        // borderWidth: 1
    },
    container: {
        flex: 1,
        justifyContent: 'center',
        alignItems: 'center',
        margin: 10,
    },
    sectionStyle: {
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: '#fff',
        borderWidth: 1,
        elevation: 0,
        borderRadius: 4,
        padding: 9,
        borderColor: 'rgba(0, 0, 0, 0.12)',
        color: 'black'
    },

    genderSection: {
        flex: 1,
        justifyContent: "flex-start",
        flexDirection: 'row',
        marginTop: 5
    },
    genderLabel: {
        color: AppTheme.color.primary
    },
    genderImages: {
        height: 50,
        width: 50,
        marginTop: 10,
    },
    imageBorder: {
        borderColor: AppTheme.color.primary,
        borderWidth: 4,
        borderRadius: 50
    },
    imageStyle: {
        paddingRight: 10,
        marginHorizontal: 10,
        height: 15,
        width: 15,
        resizeMode: 'stretch',
        alignItems: 'center',
        elevation: 0
    },
    logoLocation: {
        height: 15,
        width: 15,
        resizeMode: 'stretch',
        alignItems: 'center',
        elevation: 0,
        paddingRight: 10,
        marginHorizontal: 10,
    },
    genderElement: {
        width: 90,
        marginLeft: 10
    },
    relationSelection: {
        // flex: 1,
        flexDirection: "row",
        flexWrap: "wrap",
        textAlign: "center",
        alignContent: "center",
        justifyContent: 'space-evenly',
        // height: 50,
        marginVertical: 16
    },
    familyMembers: {
        borderRadius: 4,
        justifyContent: 'center',
        borderWidth: 1.5,
        padding: 2,
        paddingVertical: 5,
        borderColor: AppTheme.color.lightGreyColor,
        margin: 5,
        width: 90,
        // height: 30,
    },
    selectedRelated: {
        backgroundColor: AppTheme.color.primary,
        color: '#fff'
    },
    relations: {
        fontSize: 14,
        paddingVertical: 10
    },
    textLocation: {
        flex: 1, borderColor: 'white', height: 35, fontSize: 14, fontWeight: '600', padding: 10
    },
    dateInput: {
        flex: 1, borderColor: 'white', height: 35,
        fontSize: 14, fontWeight: 600, padding: 10
    }

}))